/**
 * Traduções de navegação
 * Inclui: Navegação inferior, navegação superior
 */
export default {
  home: 'Início',
  message: 'Mensagem',
  messages: 'Mensagens',
  strangerMessages: 'Mensagens de Estranhos',
  follow: 'Seguir',
  profile: 'Perfil',
  video: 'Chamada de Vídeo',
  chat: 'Chat',
  vip: 'VIP',
  userDetail: 'Detalhes do Usuário',
  diamond: 'Diamante',
}
